import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <div className="privacy-policy-card">
          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">Adatvédelmi Szabályzat & Általános Szerződési Feltételek</h1>
            <div className="privacy-policy-date">Hatályos: 2025.01.01.</div>
          </div>
          <div className="privacy-policy-section">
            <h2>Adatvédelmi Szabályzat</h2>
            
            <h3>1. Gyűjtött adatok</h3>
            <p>Az alkalmazás használata során az alábbi típusú adatokat gyűjtjük:</p>
            <ul>
              <li>Személyes adatok: név, e-mail cím, felhasználónév, jelszó</li>
              <li>Helyadatok: GPS-alapú helymeghatározás a nyomkövetéshez</li>
              <li>Technikai adatok: eszközinformációk, IP-címek, és alkalmazáshasználati adatok</li>
            </ul>

            <h3>2. Adatfelhasználás</h3>
            <p>Az adatokat az alábbi célokra használjuk fel:</p>
            <ul>
              <li>Az alkalmazás szolgáltatásainak biztosítása és fejlesztése</li>
              <li>Nyomkövetési és navigációs funkciók biztosítása</li>
              <li>Ügyfélszolgálati támogatás nyújtása</li>
              <li>Értesítések küldése az alkalmazáson belüli tevékenységekről</li>
            </ul>

            <h3>3. Adattovábbítás</h3>
            <p>Az Ön személyes adatait harmadik féllel nem osztjuk meg, kivéve, ha ezt jogszabály írja elő, vagy ha Ön hozzájárul.</p>

            <h3>4. Adatbiztonság</h3>
            <p>Az Ön adatait titkosítva tároljuk és kezeljük, hogy illetéktelen személyek ne férhessenek hozzá.</p>

            <h3>5. Az Ön jogai</h3>
            <p>Ön jogosult hozzáférni, módosítani vagy töröltetni személyes adatait, valamint visszavonni hozzájárulását az adatkezeléshez.</p>

            <h3>6. Kapcsolat</h3>
            <p>Bármilyen kérdése vagy panasza van, kérjük, forduljon hozzánk az alábbi elérhetőségen:</p>
            <p>E-mail cím: <a href="mailto:caminotiszato@gmail.com">caminotiszato@gmail.com</a></p>
          </div>
          <div className="privacy-policy-section">
            <h2>Általános Szerződési Feltételek</h2>
            
            <h3>1. Az alkalmazás használata</h3>
            <p>Az alkalmazás célja, hogy felhasználóink számára nyomkövetési és navigációs szolgáltatásokat nyújtson. A felhasználók vállalják, hogy az alkalmazást kizárólag jogszerű célokra használják.</p>

            <h3>2. Fiók regisztráció</h3>
            <p>Az alkalmazás használatához regisztráció szükséges. A felhasználó köteles pontos és teljes adatokat megadni a regisztráció során.</p>

            <h3>3. Felhasználói felelősség</h3>
            <p>A felhasználók nem használhatják az alkalmazást törvénytelen tevékenységekhez. A felhasználói fiókok jogosulatlan használata esetén a szolgáltató jogosult a fiókokat felfüggeszteni vagy megszüntetni.</p>

            <h3>4. Szerzői jog</h3>
            <p>Az alkalmazásban található tartalmak (pl. képek, szövegek, logók) a szolgáltató tulajdonát képezik. Ezek másolása, terjesztése csak a szolgáltató előzetes írásos hozzájárulásával lehetséges.</p>

            <h3>5. Adatvédelem</h3>
            <p>Az Ön adatait az Adatvédelmi Szabályzat szerint kezeljük.</p>

            <h3>6. Felelősség korlátozása</h3>
            <p>A szolgáltató nem vállal felelősséget az alkalmazás használata során keletkezett károkért, beleértve az adatvesztést vagy technikai hibákat.</p>

            <h3>7. Szolgáltatás megszüntetése</h3>
            <p>A szolgáltató fenntartja a jogot, hogy az alkalmazás működését bármikor, előzetes értesítés nélkül megszüntesse vagy módosítsa.</p>

            <h3>8. Alkalmazandó jog</h3>
            <p>Jelen szerződésre a magyar jog az irányadó, és bármilyen jogvita esetén a magyar bíróságok illetékesek.</p>

            <h3>9. Kapcsolat</h3>
            <p>Kérdések vagy panaszok esetén kérjük, vegye fel velünk a kapcsolatot:</p>
            <p>E-mail cím: <a href="mailto:caminotiszato@gmail.com">caminotiszato@gmail.com</a></p>
          </div>

          <div className="privacy-last-update">Utolsó frissítés: 2025.03.19.</div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 